import { FiLock } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const PasswordField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="password"
    placeholder={field.placeholder || field.label}
    icon={FiLock}
    disabled={disabled}
    required={field.is_required}
  />
);

export default PasswordField;
